<div>
    <form [formGroup]="teamForm" (ngSubmit)="onSubmit($event)"> 
        <div class="mb-3 px-4">
            <label for="name" class="form-label">Name</label>
            <input 
                type="text" 
                id="name" 
                class="form-control"
                placeholder="Enter your name"
                formControlName="name"
                required>
        </div>               
        <div class="mb-3 px-4">
            <label for="description" class="form-label">Description</label>
            <input 
                type="text" 
                id="description" 
                class="form-control"
                placeholder="Add description"
                formControlName="description"
                required minlength="5">
        </div>     
        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-add" type="submit">
                Add
            </button>
        </div>
    </form>
</div>

